import _ from 'lodash';

// we want to skip this spell as it just means +5 item level which isn't very interesting
const BONUS_ITEM_LEVEL_SPELLID = 263978;

export function getSortedAzeritePowers(powers: any[]) {
  const compactPowers = _.compact(powers).filter(
    (power: any) => power.spell.id !== 0 && power.spell.id !== BONUS_ITEM_LEVEL_SPELLID
  );
  const counts = compactPowers.reduce((accum: any, power: any) => {
    if (!accum[power.id]) {
      accum[power.id] = 1;
    } else {
      accum[power.id]++;
    }
    return accum;
  }, {});
  return compactPowers.sort(sortAzeritePowers.bind(null, counts));
}

function sortAzeritePowers(counts: any, a: any, b: any) {
  if (counts[b.id] === counts[a.id]) {
    if (a.tier === b.tier) {
      return a.id - b.id; // equal counts means *consistently* sort relative to eachother
    }
    return b.tier - a.tier;
  }
  // otherwise sort by the more attributes
  return counts[b.id] - counts[a.id];
}

export function processCharacterSpecialItems(items: any) {
  const specialItems: any = _.toPairs<any>(items).reduce(
    (acc, [slot, item]: any) => {
      // allItems.push(formatComparisonItem(item));

      if (item.is_legendary) {
        acc.legendaries.push(item);
      }

      if (item.tier) {
        const key = `tier${item.tier}`;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(item);
      }

      if (slot === 'trinket1' || slot === 'trinket2') {
        acc.trinkets.push(item);
      }

      if (slot === 'neck' && item.heart_of_azeroth) {
        acc.heartLevel = item.heart_of_azeroth.level + item.heart_of_azeroth.progress;
        acc.essences = item.heart_of_azeroth.essences;
      }

      if (item.domination_shards?.length > 0) {
        acc.dominationShards.push(...item.domination_shards);
        acc.dominationSocketItems.push(item);
      }

      acc.azeritePowers.push(item.azerite_powers);

      return acc;
    },
    {
      trinkets: [],
      legendaries: [],
      dominationSocketItems: [],
      dominationShards: [],
      azeritePowers: [],
      heartLevel: 0
    } as any
  );

  specialItems.azeritePowers = getSortedAzeritePowers(_.flatten(specialItems.azeritePowers));

  // consistently sort trinkets
  specialItems.trinkets.sort((a: any, b: any) => a.item_id - b.item_id);

  return specialItems;
}
